import React, { useState, useEffect } from 'react';
import { API_URL } from '../../config';
import { authFetch } from '../../utils';

export default function GatewayAlertsTab() {
  const [gateways, setGateways] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState(null);

  useEffect(() => {
    authFetch(`${API_URL}gateways/`)
      .then(res => res.ok ? res.json() : [])
      .then(data => setGateways(Array.isArray(data) ? data : []))
      .catch(() => setGateways([]))
      .finally(() => setLoading(false));
  }, []);

  const toggleAlerts = async (gateway) => {
    setSavingId(gateway._id);
    try {
      const res = await authFetch(`${API_URL}gateways/${gateway._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ alertsEnabled: !gateway.alertsEnabled })
      });
      if (!res.ok) throw new Error('Error al actualizar');
      const updated = await res.json();
      setGateways(prev => prev.map(g => g._id === updated._id ? updated : g));
    } catch (err) {
      console.error(err);
      alert('Error al actualizar el gateway');
    } finally {
      setSavingId(null);
    }
  };

  if (loading) return <p style={{ color: '#6c757d' }}>Cargando gateways...</p>;

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '1rem' }}>
      <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem', textAlign: 'center' }}>
        📡 Gateways
      </h2>
      <p style={{ fontSize: '13px', color: '#6c757d', marginBottom: '1.5rem' }}>
        Avisa por Telegram (grupo de alarmas) si un gateway no recibe ningún envío en 4 horas, como máximo una vez al día. Desactívalo para un gateway concreto si sabes que está desconectado a propósito.
      </p>

      {gateways.length === 0 ? (
        <p style={{ color: '#6c757d' }}>No hay gateways registrados.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {gateways.map(gateway => (
            <li
              key={gateway._id}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#f9f9f9',
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '0.75rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
              }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>{gateway.name}</div>
                <div style={{ fontFamily: 'monospace', fontSize: '12px', color: '#666' }}>{gateway.gatewayId}</div>
              </div>

              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '13px' }}>
                {gateway.alertsEnabled ? 'Avisos activados' : 'Avisos desactivados'}
                <input
                  type="checkbox"
                  checked={!!gateway.alertsEnabled}
                  disabled={savingId === gateway._id}
                  onChange={() => toggleAlerts(gateway)}
                />
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
